import { Injectable } from '@angular/core';
import { User } from '../../models/intefaces/user';
import { Request } from '../../models/intefaces/request';

const ProcessIdKey = 'processId';
const UserKey = 'user';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private user?: User;

  private processId: string;

  constructor() {
    const user = sessionStorage.getItem(UserKey);
    if (user) {
      this.user = JSON.parse(user);
    }
    this.processId = sessionStorage.getItem(ProcessIdKey) || '';
  }

  setUser(user: User): void {
    this.user = user;
    sessionStorage.setItem(UserKey, JSON.stringify(user));
  }

  getApiToken(): string {
    return this.user?.api_token || '';
  }

  getToken(): string {
    return this.user?.token || '';
  }

  getProcessId(): string {
    return this.processId;
  }

  getLastOrder(): Request {
    if (!this.user?.requests || this.user.requests.length === 0) {
      throw new Error('No request for this user');
    }
    this.user.requests.sort((requestA, requestB) =>
      this.compareRequests(requestA, requestB)
    );
    return this.user?.requests[0];
  }

  setProcessId(id: string): void {
    this.processId = id;
    sessionStorage.setItem(ProcessIdKey, this.processId);
  }

  reset(): void {
    delete this.user;
  }

  private compareRequests(requestA: Request, requestB: Request): number {
    const dateA = new Date(requestA.created_at);
    const dateB = new Date(requestB.created_at);
    return dateA < dateB ? 1 : dateA > dateB ? -1 : 0;
  }
}
